import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { eventCategoryService } from "@project/services/admin/event-category.service";
import type { EventCategory, EventCategoryPayload } from "@project/types/event";

const fields: Field[] = [
  {
    name: "category_name",
    label: "Category Name",
    required: true,
    showInTable: true,
    placeholder: "e.g. Dharma & Pravachan",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    showInTable: true,
    placeholder: "Brief description of this category",
  },
  {
    name: "is_active",
    label: "Active",
    type: "boolean",
    showInTable: true,
  },
];

function toPayload(payload: Record<string, unknown>): EventCategoryPayload {
  return {
    category_name: String(payload.category_name ?? "").trim(),
    description: String(payload.description ?? "").trim(),
    is_active: payload.is_active === true || payload.is_active === "true",
  };
}

export default function EventCategoriesPage() {
  return (
    <AdminShell
      title="Event Categories"
      subtitle="Manage spiritual, medical, and community activity classifications"
    >
      <ApiResourceTable<EventCategory>
        title="Category"
        labelField="category_name"
        fields={fields}
        searchFields={["category_name", "description"]}
        defaultValues={{ is_active: true }}
        statusFilterOptions={[
          { value: "active", label: "Active" },
          { value: "inactive", label: "Inactive" },
        ]}
        csvFileName="event-categories"
        list={query => eventCategoryService.listPage(query)}
        create={payload => eventCategoryService.create(toPayload(payload))}
        update={(id, payload) =>
          eventCategoryService.update(id, toPayload(payload))
        }
        remove={id => eventCategoryService.delete(id)}
      />
    </AdminShell>
  );
}
